import React, { useContext, useState } from 'react'
import Logo from '../../../assets/Be Alright Light Logo.svg'
import { useNavigate } from 'react-router-dom'
import { DContext } from '../../../context/DataContext'
import { useTranslation } from 'react-i18next'
import { FiMenu, FiShoppingBag, FiUser } from 'react-icons/fi'
import { MdCurrencyExchange, MdGTranslate } from 'react-icons/md'
import HeaderOffCanvas from '../HeaderOffCanvas'

function Header(props) {

  const { t } = useTranslation()

  const { cart, isAuth, setCurrency, currency } = useContext(DContext)

  const navPage = useNavigate()
  const [renderLnDropdown, setRenderLnDropdown] = useState(false)
  const [renderCrDropdown, setRenderCrDropdown] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const renderCurrency = () => {
    if (currency === "usd") {
      return props.ln === "ts" ? "ดอลลาร์" : "Dollar"
    }
    else if (currency === "thb") {
      return props.ln === "ts" ? "เงินบาท" : (props.ln === "fr" ? "Baht thaïlandais" : "Thai Baht")
    }
  }

  const handleAccount = () => {
    if (isAuth) {
      window.location.href = "/account"
    }
    else {
      window.location.href = "/login"
    }
  }


  return (
    <>
      <header className='sticky top-0 left-0 z-[1051] flex items-center justify-between bg-transparent px-3 py-2'>
        <img className='w-[40%] min-[687px]:w-[180px]' src={Logo} alt='Be Alright Krabi Logo' role='button' onClick={() => navPage('/')} />
        <nav className='flex items-center justify-center gap-2'>
          <button className='relative hidden min-[687px]:inline-flex items-center gap-1.5 rounded-full border border-slate-100 px-3 py-1.5 text-sm font-medium text-slate-50 transition hover:bg-white/15' onClick={() => navPage('/bucket-list')}>
            <FiShoppingBag className='text-base' />
            {t("sliderMenu.bucketList")}
            <span className='absolute left-full top-0 -translate-y-1/2 -translate-x-1/2 rounded-full bg-rose-600 px-2 text-xs font-bold text-white'>{cart.length}</span>
          </button>

          <div className='relative'>
            <button className='inline-flex items-center gap-1.5 rounded-full border border-slate-100 px-3 py-1.5 text-sm font-medium text-slate-50 transition hover:bg-white/15' onClick={() => setRenderLnDropdown(!renderLnDropdown)}>
              <MdGTranslate className='text-base' />
              {props.ln === 'en' && 'English'}
              {props.ln === 'fr' && 'Français'}
              {props.ln === 'ts' && 'แบบไทย'}
            </button>
            {renderLnDropdown && <ul className='absolute right-0 z-[1001] mt-2 min-w-[150px] overflow-hidden rounded-lg border border-slate-200 bg-white py-1 text-base text-slate-900 shadow-lg'>
              <li className='cursor-pointer px-3 py-2 hover:bg-slate-100' role='button' onClick={() => { props.changeLanguage('en'); setRenderLnDropdown(false) }}>English</li>
              <li className='cursor-pointer px-3 py-2 hover:bg-slate-100' role='button' onClick={() => { props.changeLanguage('fr'); setRenderLnDropdown(false) }}>Français</li>
              <li className='cursor-pointer px-3 py-2 hover:bg-slate-100' role='button' onClick={() => { props.changeLanguage('ts'); setRenderLnDropdown(false) }}>แบบไทย</li>
            </ul>}
          </div>

          <div className='relative hidden min-[687px]:block'>
            <button className='inline-flex items-center gap-1.5 rounded-full border border-slate-100 px-3 py-1.5 text-sm font-medium text-slate-50 transition hover:bg-white/15' onClick={() => setRenderCrDropdown(!renderCrDropdown)}>
              <MdCurrencyExchange className='text-base' />
              {renderCurrency()}
            </button>
            {
              renderCrDropdown &&
              <ul className='absolute right-0 z-[1001] mt-2 min-w-[170px] overflow-hidden rounded-lg border border-slate-200 bg-white py-1 text-base text-slate-900 shadow-lg'>
                <li className='cursor-pointer px-3 py-2 hover:bg-slate-100' role='button' onClick={() => { setCurrency('thb'); setRenderCrDropdown(false) }}>{'฿'} {props.ln === "ts" && "เงินบาท"} {props.ln === "en" && "Thai Baht"} {props.ln === "fr" && "Baht thaïlandais"}</li>
              </ul>
            }
          </div>
          <button className='hidden min-[687px]:inline-flex rounded-full border border-slate-100 p-1.5 text-xl text-slate-50 transition hover:bg-white/15' onClick={handleAccount} aria-label='Account'>
            <FiUser />
          </button>
          <button className='inline-flex rounded-full border border-slate-100 p-1.5 text-xl text-slate-50 transition hover:bg-white/15' type='button' onClick={() => setIsMobileMenuOpen(true)} aria-label='Open menu'>
            <FiMenu />
          </button>
        </nav>
      </header>

      <HeaderOffCanvas
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        ln={props.ln}
      />
    </>
  )
}

export default Header
